import {FormItemBase} from './form-item-base';

export class FormItemDropdown extends FormItemBase<string> {
  controlType = 'dropdown';
}
